module.exports = {"priceNote":"*A service fee will be added to this transaction.","flexpassName":"Flexpass","maxTickets":"Maximum number of redeemable tickets:"}


//////////////////
// WEBPACK FOOTER
// ./src/components/EventListing/Flexpass/FlexpassDetails/locales/en.json
// module id = 1134
// module chunks = 0